// Libs
import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
// Context
import { useComponentsPool } from '../../../ComponentsPool';
import { getKanbanVersionWsValue } from '../../core/helper';
import { isMobile } from 'react-device-detect';
import { isNewSystem } from '../../../switch';

export default () => {
    const { Component } = useComponentsPool();
    const userWorkspaceRights = useSelector(state => state.users.currentUser.workspace_rights);
    const groupList = useSelector(state => state.groups.list);
    const ticketsActiveMode = useSelector(state => state.tickets.list.find(category => category?.id !== 'ARCHIVED')?.isVisible === true);
    const workspaceSettings = useSelector(state => state.workspace.settings);
    const currentUser = useSelector(state => state.users.currentUser);
    const canSeeNewKanban = getKanbanVersionWsValue(workspaceSettings.kanban_version, currentUser) === 'NEW';
    const hasTicketCreationV2Mobile = isNewSystem() && isMobile;

    console.log('canSeeNessswKkkkkanban', canSeeNewKanban);
    if (!isEmpty(groupList) && !canSeeNewKanban) {
        return (
            <Component
                componentName={'ActionButton'}
                canUserCreate={userWorkspaceRights.includes('CREATE:Ticket') && ticketsActiveMode}
                modalName={isNewSystem() ? 'TicketCreatePopupV2' : 'TicketCreatePopup'}
                iconButton={(<Component componentName={'Icon'} type={hasTicketCreationV2Mobile ? 'plus' : 'ticket_action_button'} />)}
                tooltipTitle={'tickets:ticket_ticketbutton'}
            />
        );
    }
    return <></>;
};
